import { useService } from "@xstate/react";
import React, { ReactNode } from "react";
// @ts-ignore
import { useTabIndex } from "react-tabindex";
import styled from "styled-components";
import { productBuilderMachine } from "../../../context/ProductBuilder/machine";
import { getStateKey } from "../../../helpers/getStateKey";

import { SelectedIcon } from "./SelectedIcon";

type Props = {
  children?: ReactNode;
  Icon?: any;
  title?: string;
  description?: string;
  showIcon?: boolean;
  isSelected: boolean;
  onClick: () => void;
};

const StyledButton = styled.div<{
  isSelected: boolean;
  currentState: string;
  title: any;
}>`
  width: 100%;
  margin: 8px 12px;
  min-width: auto !important;
  position: relative;
  border-radius: 8px;
  padding: 12px;

  ${({ title }) => {
    if (title === "Reveal Fit") {
      return `max-width: calc(50% - 24px) !important;`;
    } else if (title === "Face Fit") {
      return `max-width: calc(50% - 24px) !important;`;
    } else if (title === "Left") {
      return `max-width: calc(50% - 24px) !important;`;
    } else if (title === "Right") {
      return `max-width: calc(50% - 24px) !important;`;
    } else if (title === "Light Guards") {
      return `max-width: calc(50% - 24px) !important;`;
    } else if (title === "No Light Guards") {
      return `max-width: calc(50% - 24px) !important;`;
    }
    return `max-width: calc(33.33% - 24px) !important;`;
  }};

  ${({ isSelected }) => {
    if (isSelected) {
      return `border : 1px solid #26375F; box-shadow: rgb(38 55 95) 0px 0px 0px 1px;`;
    }
    return `border : 2px solid var(--bs-s-dark-color); box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05)`;
  }};

  ${({ isSelected }) => {
    if (isSelected) {
      return `background-color: rgba(0, 0, 0, 0.05);`;
    }
    return `background-color: #fff;`;
  }};

  ${({ currentState }) => {
    if (
      currentState === "numberOfPanels" ||
      currentState === "panelConfiguration"
    )
      return "width: 100%; max-width: initial ;min-width: initial;text-align: center;";
  }}

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    border: 2px solid #26375f;
    box-shadow: 0 0 0 1px #26375f;
  }

  &:focus {
    outline: 0;
  }

  @media (max-width: 767px) {
    margin: 6px 0;
    max-width: 100% !important;
    min-width: auto !important;
    padding: 12px 8px;

    width: calc(33.33% - 5.9px) !important;

    &:first-child {
      margin-left: 0px;
    }
    &:last-child {
      margin-right: 30px;
      ${({ currentState }) => currentState === 'wand_option' && 'margin-right: 6px;'}
    }
  }
`;

const StyledIconWrapper = styled.div<{
  currentState: string;
}>`
  margin: 0 auto;
  padding-top: 20px;
  width: 56px;

  svg {
    vertical-align: middle;
    width: 56px;
    height: 56px;
  }

  @media (max-width: 768px) {
    width: 70px;
    padding-top: 5px;
    ${({ currentState }) => {
      if (
        currentState === "numberOfPanels" ||
        currentState === "panelConfiguration"
      )
        return " width: auto;";
    }}
  }

  ${({ currentState }) => {
    if (
      currentState === "numberOfPanels" ||
      currentState === "panelConfiguration"
    )
      return " width: auto;";
  }}
`;

const StyledTitle = styled.div`
  text-align: center;
  font: normal normal normal 14px/17px Lato;
  letter-spacing: 0px;
  color: #242325;
  margin-top: 12px;
  cursor: default;
  @media (max-width: 767px) {
    font-size: 12px;
  }
`;

const StyledDescription = styled.div`
  text-align: center;
  font: normal normal 300 12px/15px Lato;
  letter-spacing: 0px;
  color: #242325;
  margin-top: 10px;
  cursor: default;
  @media (max-width: 767px) {
    font-size: 10px;
    margin-top: 5px;
    line-height: 1.3;
  }
`;

const SelectorImageItem = ({
  children,
  Icon,
  showIcon,
  title,
  description,
  isSelected,
  onClick = () => {},
}: Props) => {
  const tabIndex: number = useTabIndex();
  const [state] = useService(productBuilderMachine);
  const stateKey = getStateKey(state.value);
  return (
    <>
      <StyledButton
        tabIndex={tabIndex}
        title={title}
        currentState={stateKey}
        isSelected={isSelected}
        onClick={onClick}
        className="keen-slider-selector__slide"
      >
        {isSelected && <SelectedIcon />}
        {showIcon && (
          <StyledIconWrapper currentState={stateKey}>
            <Icon />
          </StyledIconWrapper>
        )}
        <StyledTitle>{title}</StyledTitle>
        {description && <StyledDescription>{description}</StyledDescription>}
        {children}
      </StyledButton>
    </>
  );
};

export default SelectorImageItem;
